import { render, staticRenderFns } from "./CardsBlock.vue?vue&type=template&id=72d2f62a&lang=pug&"
import script from "./CardsBlock.vue?vue&type=script&lang=js&"
export * from "./CardsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports